import { adminUser } from './mockData'
import { adminAccounts } from './adminExtendedData'
import { canPermission, normalizePermissions } from './adminPermissions'

const ADMIN_KEY = 'difan-admin-accounts-v1'

export function getCurrentAdminAccount() {
  try {
    const stored = JSON.parse(localStorage.getItem(ADMIN_KEY) || 'null')
    const rows = Array.isArray(stored) ? stored : adminAccounts
    return rows.find((item) => item.id === adminUser.id) || { ...adminUser }
  } catch {
    return { ...adminUser }
  }
}

export function getCurrentAdminPermissions() {
  const current = getCurrentAdminAccount()
  return normalizePermissions(current.role || adminUser.role, current.permissions)
}

export function currentAdminCan(route, action = 'view') {
  return canPermission(getCurrentAdminPermissions(), route, action)
}
